import Page from 'pages/Page';

export default class LandingCollection extends Page {}

new LandingCollection();
